// src/components/features/Elevation/components/ElevationStep8Windows.jsx

import ElevationRadioStep from "./shared/ElevationRadioStep";
import { WINDOWS_IMAGES } from "../../../../assets/Elevation/elevationAssets";

// ]
const OPTIONS = [
  {
    id: "aluminium",
    label: "Aluminium Sliding Window",
    sub: "Sleek aluminium frame sliding windows",
    images: [WINDOWS_IMAGES[1].img, WINDOWS_IMAGES[2].img],
  },
  {
    id: "wooden",
    label: "Wooden Window",
    sub: "Traditional solid wood frame windows",
    images: [WINDOWS_IMAGES[4].img, WINDOWS_IMAGES[3].img],
  },  
];

export default function ElevationStep8Windows(props) {
  return (
    <ElevationRadioStep
      {...props}
      title="Windows"
      subtitle="Choose the window type for your elevation"
      options={OPTIONS}
      fieldKey="elevationWindows"
    />
  );
}